import moji from '../../public/assets/plugins/moji/moji.js';

const InputValueConversion = {

    // 両端の空白を削除
    spaceRemoval(inputValue) {
        return inputValue.trim(/\s/, '');
    },
    // ハイフンを削除
    hyphenRemoval(inputValue) {
        return inputValue.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '');
    },
    // 全角を半角に変換（英数字）
    fullWidthToHalfWidthAlphanum(inputValue) {
        return inputValue.replace(/[Ａ-Ｚａ-ｚ０-９]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    },
    // 全角を半角に変換（記号英数字）
    fullWidthToHalfWidthSymbolAlphanum(inputValue) {
        return inputValue.replace(/[Ａ-Ｚａ-ｚ０-９！＃＄％＆（）\*\+,:;<=>?@\[\\］＾＿`｛｜｝～]/g, function(s) {
            return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
        });
    },
    // ひらがなをカタカナに変換（moji.js）
    // 半角カナを全角カナに変換（moji.js）
    toKana(inputValue) {
        inputValue = moji(inputValue).convert('HGtoKK').toString();
        inputValue = moji(inputValue).convert('HKtoZK').toString();
        return inputValue;
    },
    // 全角英数を半角英数に変換（moji.js）
    toHalfSize(inputValue) {
        return moji(inputValue).convert("ZEtoHE").convert("ZStoHS").toString();
    },
    //文字列のYYYY-MM-DD HH:MM:SS がくる YYYY年MM月DD日にして返す
    convertedToDateStringForDisplay(dateString) {
        if (!dateString) return ""
        const date = new Date(dateString.replace(/-/g,"/"));
        if (!Number.isNaN(date.getTime())) {
            return date.toLocaleDateString('ja-JP', {
                weekday: 'short',
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        }
        return ""
    },
}

export default InputValueConversion;